export function initOffcanvas() {
	// Add/remove class on #site-header when offcanvasTop is shown/hidden
	const offcanvasTopEl = document.getElementById('offcanvasTop');
	const siteHeader = document.getElementById('site-header');
	if (offcanvasTopEl && siteHeader) {
		offcanvasTopEl.addEventListener('show.bs.offcanvas', () => {
			siteHeader.classList.add('offcanvasTop-open');
		});
		offcanvasTopEl.addEventListener('hide.bs.offcanvas', () => {
			siteHeader.classList.remove('offcanvasTop-open');
		});
	}

	// ── Offcanvas Direction ──────────────────────────────────────────────────────
	function updateOffcanvasDirection() {
		const offcanvas = document.getElementById('offcanvasTop');

		if (window.innerWidth < 768) {
			offcanvas.classList.remove('offcanvas-top');
			offcanvas.classList.add('offcanvas-end');
		} else {
			offcanvas.classList.remove('offcanvas-end');
			offcanvas.classList.add('offcanvas-top');
		}
	}

	updateOffcanvasDirection();
	window.addEventListener('resize', updateOffcanvasDirection);
}
